import Vue from "vue"
import global_mixin from "~/mixins/global"

Vue.mixin(global_mixin)
export default {}
